(function () {
  'use strict';

  if (window.__kkGridLaunchCountdownInitialized) {
    return;
  }

  window.__kkGridLaunchCountdownInitialized = true;

  var timer = null;
  var OPEN_DATE_THRESHOLD_MS = 90 * 86400 * 1000;

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function formatCountdown(diffMs, dayOne, dayMany) {
    var total = Math.max(0, Math.floor(diffMs / 1000));
    var days = Math.floor(total / 86400);
    var hours = Math.floor((total % 86400) / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    var seconds = total % 60;
    var time = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    var dayLabel = days === 1 ? (dayOne || 'p\u00e4iv\u00e4') : (dayMany || 'p\u00e4iv\u00e4\u00e4');

    return days > 0 ? days + ' ' + dayLabel + ' ' + time : time;
  }

  function dispatchExpiry(countdown, target) {
    if (countdown.getAttribute('data-expiry-event-sent') === 'true') {
      return;
    }

    countdown.setAttribute('data-expiry-event-sent', 'true');
    countdown.dispatchEvent(new CustomEvent('kk:grid-launch-expired', {
      bubbles: true,
      detail: { target: target }
    }));
  }

  function setDisplay(element, value) {
    if (element) {
      element.style.display = value;
    }
  }

  function updateProductCountdown(countdown, target, diffMs) {
    var countWrap = countdown.querySelector('[data-count]');
    var liveWrap = countdown.querySelector('[data-live]');
    var dateWrap = countdown.querySelector('[data-release-date]');
    var daysElement = countdown.querySelector('[data-days]');
    var daysWordElement = countdown.querySelector('[data-daysword]');
    var timeElement = countdown.querySelector('[data-time]');
    var dayOne = countdown.getAttribute('data-day-one') || 'p\u00e4iv\u00e4';
    var dayMany = countdown.getAttribute('data-day-many') || 'p\u00e4iv\u00e4\u00e4';
    var openText = countdown.getAttribute('data-open-text') || 'Ajankohta avoin';
    var total;
    var days;
    var hours;
    var minutes;
    var seconds;

    countdown.hidden = false;
    countdown.setAttribute('aria-hidden', 'false');

    if (diffMs <= 0) {
      setDisplay(countWrap, 'none');
      setDisplay(liveWrap, '');
      setDisplay(dateWrap, '');
      dispatchExpiry(countdown, target);

      if (
        countdown.getAttribute('data-reload-on-expiry') === 'true' &&
        countdown.getAttribute('data-reload-scheduled') !== 'true'
      ) {
        countdown.setAttribute('data-reload-scheduled', 'true');
        window.setTimeout(function () {
          window.location.reload();
        }, 400);
      }

      return false;
    }

    countdown.removeAttribute('data-expiry-event-sent');
    countdown.removeAttribute('data-reload-scheduled');
    setDisplay(countWrap, '');
    setDisplay(liveWrap, 'none');

    if (diffMs > OPEN_DATE_THRESHOLD_MS) {
      setDisplay(dateWrap, 'none');
      setDisplay(daysElement, 'none');
      setDisplay(daysWordElement, 'none');

      if (timeElement) {
        timeElement.style.marginLeft = 'auto';
        timeElement.style.marginRight = 'auto';
        timeElement.style.textAlign = 'center';
        timeElement.textContent = openText;
      }

      return true;
    }

    total = Math.max(0, Math.floor(diffMs / 1000));
    days = Math.floor(total / 86400);
    hours = Math.floor((total % 86400) / 3600);
    minutes = Math.floor((total % 3600) / 60);
    seconds = total % 60;

    setDisplay(dateWrap, '');

    if (days > 0) {
      setDisplay(daysElement, '');
      setDisplay(daysWordElement, '');

      if (daysElement) {
        daysElement.textContent = String(days);
      }
      if (daysWordElement) {
        daysWordElement.textContent = days === 1 ? dayOne : dayMany;
      }
      if (timeElement) {
        timeElement.style.marginLeft = '';
        timeElement.style.marginRight = '';
        timeElement.style.textAlign = '';
      }
    } else {
      setDisplay(daysElement, 'none');
      setDisplay(daysWordElement, 'none');

      if (timeElement) {
        timeElement.style.marginLeft = 'auto';
        timeElement.style.marginRight = 'auto';
        timeElement.style.textAlign = 'center';
      }
    }

    if (timeElement) {
      timeElement.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    }

    return true;
  }

  function updateGridCountdown(countdown, target, diffMs) {
    var timeElement = countdown.querySelector('[data-grid-launch-time]');
    var dayOne = countdown.getAttribute('data-day-one') || 'p\u00e4iv\u00e4';
    var dayMany = countdown.getAttribute('data-day-many') || 'p\u00e4iv\u00e4\u00e4';
    var openText = countdown.getAttribute('data-open-text') || 'Ajankohta avoin';

    if (diffMs <= 0) {
      countdown.hidden = true;
      countdown.setAttribute('aria-hidden', 'true');
      dispatchExpiry(countdown, target);
      return false;
    }

    countdown.removeAttribute('data-expiry-event-sent');
    countdown.hidden = false;
    countdown.setAttribute('aria-hidden', 'false');

    if (timeElement) {
      timeElement.textContent = diffMs > OPEN_DATE_THRESHOLD_MS ?
        openText :
        formatCountdown(diffMs, dayOne, dayMany);
    }

    return true;
  }

  function updateCountdowns() {
    var countdowns = document.querySelectorAll('[data-grid-launch-countdown]');
    var activeCount = 0;

    countdowns.forEach(function (countdown) {
      var target = parseInt(countdown.getAttribute('data-target'), 10);
      var diffMs;

      if (!isFinite(target)) {
        countdown.hidden = true;
        countdown.setAttribute('aria-hidden', 'true');
        return;
      }

      diffMs = (target * 1000) - Date.now();

      if (countdown.getAttribute('data-countdown-layout') === 'product') {
        if (updateProductCountdown(countdown, target, diffMs)) {
          activeCount += 1;
        }
      } else if (updateGridCountdown(countdown, target, diffMs)) {
        activeCount += 1;
      }
    });

    return activeCount;
  }

  function stop() {
    window.clearTimeout(timer);
    timer = null;
  }

  function refresh() {
    stop();

    if (document.hidden || updateCountdowns() === 0) {
      return;
    }

    timer = window.setTimeout(refresh, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('kk:collection-search-complete', refresh);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stop();
      return;
    }

    refresh();
  });
}());
